<template>
  <div>
    <!-- 1. POPUP MASUKKAN KODE VERIFIKASI (OTP) -->
    <BModal
      id="modal-forgot-email-pin"
      ref="modal-forgot-email-pin"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      modal-class="modal-primary"
      centered
      hide-header
    >
      <div class="d-flex justify-content-end p-1">
        <img
          src="@/assets/images/svg/close-circle.svg"
          alt="Tutup"
          class="cursor-pointer"
          @click="closeAllModals"
        >
      </div>

      <BCol class="d-flex justify-content-center">
        <h4 class="text-black font-semibold">
          Lupa PIN
        </h4>
      </BCol>

      <BCol class="d-flex justify-content-center">
        <feather-icon
          icon="MailIcon"
          size="40"
          class="text-primary"
        />
      </BCol>

      <BCol class="d-flex justify-content-center mt-1">
        <h5 class="text-black font-semibold">
          Masukkan Kode Verifikasi
        </h5>
      </BCol>

      <BCol class="d-flex justify-content-center text-center">
        <small class="text-secondary" style="max-width: 260px">
          Masukkan kode verifikasi (OTP) yang telah dikirim melalui email ke
          <strong class="text-black">{{ maskedEmail }}</strong>
        </small>
      </BCol>

      <!-- Input OTP 6 Digit (Tidak Di-masking) -->
      <BCol class="d-flex justify-content-center mt-2 mb-1">
        <VueOtpInput
          ref="otpInput"
          input-classes="otp-input"
          input-type="text"
          separator=""
          :num-inputs="6"
          :should-auto-focus="true"
          :is-input-num="true"
          @on-change="handleOnChangeOtp"
        />
      </BCol>

      <!-- Pesan Peringatan OTP Salah -->
      <BCol
        v-if="otpErrorMessage"
        class="text-center mb-1"
      >
        <small class="text-danger font-semibold">
          {{ otpErrorMessage }}
        </small>
      </BCol>

      <!-- Tombol Konfirmasi OTP (Disabled jika belum 6 digit) -->
      <BCol class="d-flex justify-content-center">
        <BButton
          variant="primary"
          block
          :disabled="otp.length < 6 || loadingSubmit"
          @click="verifyOtp"
        >
          <BSpinner v-if="loadingSubmit" small variant="light" />
          Konfirmasi
        </BButton>
      </BCol>

      <!-- Throttle Kirim Ulang OTP -->
      <BCol class="d-flex justify-content-center mb-2 mt-1 text-center">
        <small
          v-if="countdownSeconds > 0"
          class="text-muted"
        >
          Tunggu dalam <strong>{{ countdownSeconds }}</strong> detik untuk kirim ulang.
        </small>
        <div
          v-else
          class="d-flex align-items-center justify-content-center"
        >
          <small class="text-muted">Tidak menerima kode?</small>
          <BButton
            variant="flat-primary"
            size="sm"
            class="btn-icon font-semibold"
            :disabled="loadingResend"
            @click="resendOtp"
          >
            <BSpinner v-if="loadingResend" small variant="primary" />
            Kirim Ulang
          </BButton>
        </div>
      </BCol>
    </BModal>

    <!-- 2. POPUP MASUKKAN PIN BARU -->
    <BModal
      id="modal-create-new-pin"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      modal-class="modal-primary"
      centered
      hide-header
    >
      <div class="d-flex justify-content-end p-1">
        <img
          src="@/assets/images/svg/close-circle.svg"
          alt="Tutup"
          class="cursor-pointer"
          @click="closeAllModals"
        >
      </div>

      <BCol class="d-flex justify-content-center">
        <h4 class="text-black font-semibold">
          Masukkan PIN Baru
        </h4>
      </BCol>
      <BCol class="d-flex justify-content-center mt-2 mb-1">
        <CodeInput
          :loading="false"
          class="input"
          :type="showNewPin ? 'text' : 'password'"
          @change="onNewPinChange"
        />
      </BCol>

      <!-- Tombol Toggle Tampilkan / Sembunyikan -->
      <BCol class="d-flex justify-content-center">
        <BButton
          variant="flat-primary"
          class="btn-icon text-sm"
          @click="showNewPin = !showNewPin"
        >
          {{ showNewPin ? 'Sembunyikan' : 'Tampilkan' }}
        </BButton>
      </BCol>

      <BCol class="d-flex justify-content-center mt-2 pb-2">
        <BButton
          variant="primary"
          block
          :disabled="newPin.length < 6"
          @click="openConfirmPinModal"
        >
          Ganti PIN
        </BButton>
      </BCol>
    </BModal>

    <!-- 3. POPUP MASUKKAN ULANG PIN -->
    <BModal
      id="modal-confirm-new-pin"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      modal-class="modal-primary"
      centered
      hide-header
    >
      <div class="d-flex justify-content-end p-1">
        <img
          src="@/assets/images/svg/close-circle.svg"
          alt="Tutup"
          class="cursor-pointer"
          @click="closeAllModals"
        >
      </div>

      <BCol class="d-flex justify-content-center">
        <h4 class="text-black font-semibold">
          Masukkan Ulang PIN
        </h4>
      </BCol>

      <BCol class="d-flex justify-content-center mt-2 mb-1">
        <CodeInput
          :loading="false"
          class="input"
          :type="showConfirmPin ? 'text' : 'password'"
          @change="onConfirmPinChange"
        />
      </BCol>

      <!-- Toggle Tampilkan / Sembunyikan -->
      <BCol class="d-flex justify-content-center">
        <BButton
          variant="flat-primary"
          class="btn-icon text-sm"
          @click="showConfirmPin = !showConfirmPin"
        >
          {{ showConfirmPin ? 'Sembunyikan' : 'Tampilkan' }}
        </BButton>
      </BCol>

      <!-- Peringatan PIN Tidak Sama -->
      <BCol v-if="confirmErrorMessage" class="text-center mt-1">
        <small class="text-danger font-semibold">
          {{ confirmErrorMessage }}
        </small>
      </BCol>

      <BCol class="d-flex justify-content-center mt-2 pb-2">
        <BButton
          variant="primary"
          block
          :disabled="confirmPin.length < 6 || loadingSubmit"
          @click="submitUpdatePin"
        >
          <BSpinner v-if="loadingSubmit" small variant="light" />
          Ganti PIN
        </BButton>
      </BCol>
    </BModal>

    <!-- 4. POPUP SUKSES -->
    <BModal
      id="modal-success-change-pin"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center p-2">
        <b-img
          center
          width="100"
          src="@core/assets/image/icon-popup-success.png"
          class="mb-2"
        />
        <h4 class="text-black font-bold">
          PIN Berhasil Diganti
        </h4>
        <BButton
          variant="primary"
          class="mt-2 px-3"
          @click="onSuccessOk"
        >
          Tutup
        </BButton>
      </div>
    </BModal>
  </div>
</template>

<script>
import VueOtpInput from '@bachdgvn/vue-otp-input'
import CodeInput from 'vue-verification-code-input'
import {
  BCol, BButton, BModal, BSpinner, BImg,
} from 'bootstrap-vue'
import { newAxiosIns } from '@/libs/axios'
import { REQUEST_OTP_EMAIL, VERIFY_OTP_EMAIL, UPDATE_OTP_PIN } from '@/provider/url'
import { maskEmail } from '@/libs/helpers'
import forceLogout from '@/libs/auth'
import moment from 'moment'
import secureLocalStorage from '@/libs/secureLocalstorage'
import { initialAbility } from '@/libs/acl/config'

export default {
  name: 'ModalForgotPinByEmail',
  components: {
    VueOtpInput,
    CodeInput,
    BModal,
    BSpinner,
    BButton,
    BCol,
    BImg,
  },
  data() {
    return {
      emailUser: this?.$store?.state?.auth?.userData?.email,
      rawToken: '',
      encodedToken: '',
      nextRequestAt: null,
      countdownSeconds: 0,
      countdownTimer: null,

      // OTP state
      otp: '',
      loadingSubmit: false,
      loadingResend: false,
      otpErrorMessage: '',

      // PIN state
      newPin: '',
      confirmPin: '',
      showNewPin: false,
      showConfirmPin: false,
      confirmErrorMessage: '',
    }
  },
  computed: {
    maskedEmail() {
      return maskEmail(this.emailUser)
    },
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer)
  },
  methods: {
    encodeSessionToken(token) {
      // Format: btoa("{token}%pin")
      return btoa(`${token}%pin`)
    },
    openModalOtp({ token, nextRequestAt }) {
      this.rawToken = token
      this.encodedToken = this.encodeSessionToken(token)
      this.nextRequestAt = nextRequestAt
      this.otp = ''
      this.otpErrorMessage = ''
      this.startCountdown(nextRequestAt)
      this.$bvModal.show('modal-forgot-email-pin')
    },
    startCountdown(nextRequestAt) {
      if (this.countdownTimer) clearInterval(this.countdownTimer)
      if (!nextRequestAt) {
        this.countdownSeconds = 60
      } else {
        const diff = moment(nextRequestAt).diff(moment(), 'seconds')
        this.countdownSeconds = diff > 0 ? diff : 0
      }

      if (this.countdownSeconds > 0) {
        this.countdownTimer = setInterval(() => {
          this.countdownSeconds -= 1
          if (this.countdownSeconds <= 0) {
            clearInterval(this.countdownTimer)
          }
        }, 1000)
      }
    },
    handleOnChangeOtp(value) {
      this.otp = value
      this.otpErrorMessage = ''
    },
    async resendOtp() {
      this.loadingResend = true
      this.otpErrorMessage = ''
      try {
        const response = await newAxiosIns.post(REQUEST_OTP_EMAIL, {
          purpose: 'pin',
        })
        const { data } = response.data
        this.rawToken = data.token
        this.encodedToken = this.encodeSessionToken(data.token)
        this.startCountdown(data.next_request_at)
      } catch (err) {
        this.otpErrorMessage = err.response?.data?.message || 'Gagal mengirim ulang OTP'
      } finally {
        this.loadingResend = false
      }
    },
    async verifyOtp() {
      this.loadingSubmit = true
      this.otpErrorMessage = ''

      try {
        await newAxiosIns.post(VERIFY_OTP_EMAIL, {
          otp: this.otp,
          token: this.encodedToken,
        })

        // OTP Valid: Pindah ke popup Buat PIN Baru
        this.$bvModal.hide('modal-forgot-email-pin')
        this.newPin = ''
        this.showNewPin = false
        this.$bvModal.show('modal-create-new-pin')
      } catch (err) {
        const resData = err.response?.data
        const attemptLeft = resData?.data?.attempt_left

        const isAttemptLimitReached = attemptLeft !== undefined && Number(attemptLeft) <= 0
        const isUnauthorized = err.response?.status === 401 || err.response?.status === 429

        if (isAttemptLimitReached || isUnauthorized) {
          await forceLogout(this.$ability)
          return
        }

        const baseMsg = resData?.message || 'Kode OTP salah, Harap cek OTP pada email, lalu coba lagi.'
        this.otpErrorMessage = attemptLeft !== undefined
          ? `${baseMsg} (Tersisa ${attemptLeft} kali percobaan)`
          : baseMsg
      } finally {
        this.loadingSubmit = false
      }
    },
    onNewPinChange(val) {
      this.newPin = val
    },
    openConfirmPinModal() {
      this.$bvModal.hide('modal-create-new-pin')
      this.confirmPin = ''
      this.showConfirmPin = false
      this.confirmErrorMessage = ''
      this.$bvModal.show('modal-confirm-new-pin')
    },
    onConfirmPinChange(val) {
      this.confirmPin = val
      this.confirmErrorMessage = ''
    },
    async submitUpdatePin() {
      // Validasi kesamaan PIN
      if (this.newPin !== this.confirmPin) {
        this.confirmErrorMessage = 'PIN harus sama dengan PIN sebelumnya'
        return
      }

      this.loadingSubmit = true
      this.confirmErrorMessage = ''

      try {
        await newAxiosIns.post(UPDATE_OTP_PIN, {
          new_pin: this.confirmPin,
          token: this.encodedToken,
        })

        // Sukses: Buka popup sukses
        this.$bvModal.hide('modal-confirm-new-pin')
        this.$bvModal.show('modal-success-change-pin')
      } catch (err) {
        this.confirmErrorMessage = err.response?.data?.message || 'Gagal memperbarui PIN'
      } finally {
        this.loadingSubmit = false
      }
    },
    onSuccessOk() {
      this.$bvModal.hide('modal-success-change-pin')
      this.$emit('onSuccess')
    },
    closeAllModals() {
      this.$bvModal.hide('modal-forgot-email-pin')
      this.$bvModal.hide('modal-create-new-pin')
      this.$bvModal.hide('modal-confirm-new-pin')
      this.$bvModal.hide('modal-success-change-pin')
    },
  },
}
</script>

<style>
.react-code-input {
  display: flex !important;
  justify-content: center;
  gap: 12px;
}
.react-code-input > input {
  border: none !important;
  border-bottom: 2px solid rgba(0, 0, 0, 0.3) !important;
  border-radius: 0 !important;
  background: transparent !important;
  outline: none !important;
  box-shadow: none !important;
  text-align: center;
}
.react-code-input > input:focus {
  border-bottom: 2px solid #F95031 !important;
  caret-color: #F95031 !important;
}
</style>
